import React from "react";

const CheckpointCard = ({ checkpoint, hasSubmission }) => {
  const assigned = Array.isArray(checkpoint.assignedTo)
    ? checkpoint.assignedTo
    : checkpoint.assignedTo
    ? [checkpoint.assignedTo]
    : [];

  const pickedUp = Array.isArray(checkpoint.pickedUpBy)
    ? checkpoint.pickedUpBy
    : checkpoint.pickedUpBy
    ? [checkpoint.pickedUpBy]
    : [];

  const hasAssigned = assigned.length > 0;
  const hasPickedUp = pickedUp.length > 0;

  const renderAvatars = (list, color) =>
    list.slice(0, 3).map((m, idx) => {
      const initials = (m.firstName || m.email || "?")
        .split(" ")
        .map((n) => n[0])
        .slice(0, 2)
        .join("")
        .toUpperCase();

        const isValidSrc =
          m.profileImage &&
          typeof m.profileImage === "string" &&
          m.profileImage.trim().length > 5 &&
          !/placeholder\.com/i.test(m.profileImage) &&
          !/default|avatar|person\.png/i.test(m.profileImage);

      return (
        <div
          key={`${color}-${idx}`}
          title={m.firstName || m.email}
          className={`relative w-5 h-5 rounded-full ring-2 ring-${color}-400 
                      overflow-hidden bg-gray-100 text-[10px] font-semibold 
                      text-gray-700 grid place-items-center`}
        >
          {isValidSrc ? (
            <img
              src={m.profileImage}
              alt={m.firstName}
              className="w-full h-full object-cover"
              onError={(e) => {
                e.currentTarget.style.display = "none";
                e.currentTarget.parentNode.textContent = initials;
              }}
            />
          ) : (
            initials
          )}

        </div>
      );
    });

  return (
    <div
      className={`w-36 min-h-[70px] rounded-2xl border 
                  shadow-sm hover:shadow-md transition-all duration-200 
                  flex flex-col justify-between p-2 relative overflow-hidden
                  ${
                    hasSubmission
                      ? "bg-black text-white border-black shadow-[inset_0_0_6px_rgba(0,0,0,0.4)]"
                      : "bg-white border-neutral-200 text-gray-800 hover:bg-gray-50"
                  }`}
    >
      {/* Title */}
      <div
        className="text-[11px] font-semibold leading-tight mb-1 
                   break-words line-clamp-3 hover:line-clamp-none transition-all"
        title={checkpoint.text}
      >
        {checkpoint.text.length > 65
          ? checkpoint.text.slice(0, 65) + "..."
          : checkpoint.text}
      </div>

      {/* Footer: hours/week + avatars */}
      <div className="flex items-center justify-between mt-auto">
        <span
          className={`text-[10px] whitespace-nowrap ${
            hasSubmission ? "text-gray-200" : "text-gray-500"
          }`}
        >
          {checkpoint.hours}h • W{checkpoint.week}
        </span>

        <div className="flex -space-x-1 items-center">
          {hasAssigned && renderAvatars(assigned, "blue")}
          {hasAssigned && hasPickedUp && (
            <div className="mx-[2px] w-[1px] h-4 bg-gray-300" />
          )}
          {hasPickedUp && renderAvatars(pickedUp, "blue")}
          {!hasAssigned && !hasPickedUp && (
            <div
              className={`w-5 h-5 rounded-full grid place-items-center text-[9px] ${
                hasSubmission
                  ? "bg-gray-800 text-gray-200 border border-gray-700"
                  : "bg-gray-100 border border-gray-300 text-gray-400"
              }`}
              title="Unassigned"
            >
              –
            </div>
          )}
        </div>
      </div>

      {/* Subtle underline gradient */}
      <div
        className={`absolute bottom-0 left-0 w-full h-[2px] ${
          hasSubmission
            ? "bg-gradient-to-r from-zinc-700 via-gray-800 to-black"
            : "bg-gradient-to-r from-sky-400 via-indigo-400 to-fuchsia-400"
        }`}
      />
    </div>
  );
};

export default CheckpointCard;
